// Formatowanie kwot w walucie KONTA reklamowego (TRY/EUR/USD/PLN...).
//
// Koszty/budżety/CPC z Google Ads i Meta są RAW w walucie konta (bez przeliczeń),
// więc tutaj tylko formatujemy liczbę i doklejamy właściwy symbol zamiast na sztywno
// „zł". Waluta pochodzi z campaign.currency (denormalizowana z konta podczas sync).
//
// UWAGA: to dotyczy DANYCH REKLAMOWYCH. Cennik naszej subskrypcji ma osobną walutę
// rozliczeniową (PLN/EUR/USD) i NIE korzysta z tego helpera.

const SYMBOLS = { PLN: 'zł', EUR: '€', USD: '$', GBP: '£', TRY: '₺', CZK: 'Kč', RON: 'lei' };

export function currencySymbol(currency) {
  const c = (currency || 'PLN').toUpperCase();
  return SYMBOLS[c] || c;
}

/**
 * Sformatuj kwotę w podanej walucie, w polskim stylu (spacja jako separator tysięcy,
 * przecinek dziesiętny, symbol PO liczbie). Nigdy nie rzuca wyjątkiem.
 *
 * @param {number} amount
 * @param {string} currency  kod ISO (PLN/EUR/USD/TRY...), domyślnie PLN
 * @param {object} opts      { decimals } lub { minDecimals, maxDecimals }
 */
export function formatMoney(amount, currency = 'PLN', opts = {}) {
  const c = (currency || 'PLN').toUpperCase();
  const n = Number(amount) || 0;
  const { decimals } = opts;
  const min = opts.minDecimals != null ? opts.minDecimals : (decimals != null ? decimals : 2);
  const max = opts.maxDecimals != null ? opts.maxDecimals : (decimals != null ? decimals : 2);
  try {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency', currency: c, currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: min, maximumFractionDigits: max,
    }).format(n);
  } catch (e) {
    // narrowSymbol nieobsługiwany albo nieznany kod waluty -> złóż ręcznie.
    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency', currency: c,
        minimumFractionDigits: min, maximumFractionDigits: max,
      }).format(n);
    } catch (e2) {
      const num = n.toLocaleString('pl-PL', { minimumFractionDigits: min, maximumFractionDigits: max });
      return `${num} ${currencySymbol(c)}`;
    }
  }
}
